import React from "react";
import "./KidsJoyStrip.css";

const JOY_ITEMS = [
  {
    title: "They leave with a smile",
    text: "Classes are structured, but never stiff — kids get to move, laugh, and try new things.",
    accent: "coral",
    icon: (
      <svg viewBox="0 0 48 48" aria-hidden="true" focusable="false">
        <circle cx="24" cy="24" r="22" fill="currentColor" opacity="0.15" />
        <path
          d="M14 28c2.5 4 6.5 6 10 6s7.5-2 10-6"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <circle cx="17" cy="21" r="2.5" fill="currentColor" />
        <circle cx="31" cy="21" r="2.5" fill="currentColor" />
      </svg>
    ),
  },
  {
    title: "Coaches who cheer them on",
    text: "Our staff know every name, celebrate small wins, and help shy kids find their footing.",
    accent: "gold",
    icon: (
      <svg viewBox="0 0 48 48" aria-hidden="true" focusable="false">
        <path
          d="M24 6l4.8 9.7 10.7 1.6-7.8 7.6 1.8 10.7L24 30.8l-9.5 5 1.8-10.7-7.8-7.6 10.7-1.6L24 6z"
          fill="currentColor"
          opacity="0.2"
        />
        <path
          d="M24 12l3.2 6.5 7.2 1-5.2 5.1 1.2 7.1L24 27.8l-6.4 3.9 1.2-7.1-5.2-5.1 7.2-1L24 12z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    title: "Skills they can't wait to show you",
    text: "Cartwheels in the driveway, new friends, and confidence that shows up at school too.",
    accent: "berry",
    icon: (
      <svg viewBox="0 0 48 48" aria-hidden="true" focusable="false">
        <path
          d="M10 30V18l14-8 14 8v12l-14 8-14-8z"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinejoin="round"
        />
        <path
          d="M24 10v28M10 18l14 8 14-8"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];

const KidsJoyStrip = () => (
  <section className="home-joy" aria-labelledby="home-joy-heading">
    <div className="home-joy__inner">
      <header className="home-joy__header">
        <p className="home-kicker">For parents</p>
        <h2 id="home-joy-heading" className="home-joy__title">
          A gym where kids want to come back
        </h2>
        <p className="home-joy__lead">
          Professional coaching and a facility you can trust — with the warmth
          and energy that make children feel at home.
        </p>
      </header>
      <ul className="home-joy__grid">
        {JOY_ITEMS.map((item) => (
          <li
            key={item.title}
            className={`home-joy__card home-joy__card--${item.accent}`}
          >
            <span className="home-joy__icon">{item.icon}</span>
            <h3>{item.title}</h3>
            <p>{item.text}</p>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default KidsJoyStrip;
